<template>
  <div class="content">
    <section
      id="tab__content1"
      class="tab__content"
      role="tabpanel"
      aria-labelledby="description"
      aria-hidden="false"
    >
      <div class="tab__content__wrap">
        <!-- 소속기업이 없는경우 -->
        <div class="section__wrap">
          <div class="section__header">
            <div class="section__title">제출 업체 사업자 번호</div>
          </div>
          <div class="section__body line">
            <div class="common__item__wrap">
              <div class="input__wrap">
                <div class="common__item__input only__input">
                  <label class="input__label" for="bizNum">
                    사업자 번호 <span class="point">*</span>
                  </label>
                  <div class="flex">
                    <input
                      id="bizNum"
                      v-model="formattedBizno"
                      type="text"
                      placeholder="숫자만 입력"
                      maxlength="10"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section__wrap">
          <div class="section__header">
            <div class="section__title">업데이트 정보 선택</div>
            <div class="section__desc">
              증명원의 발급 번호 입력 후 확인 버튼을 눌러주세요.
              <br />표준재무제표증명은 결산시점 별로 등록할 수 있습니다.
            </div>
          </div>
          <div class="section__body line">
            <div class="common__item__wrap">
              <div class="input__wrap">
                <div class="common__item__input">
                  <label class="input__label" for="bizRegistrationName">사업자등록증명</label>
                  <div class="flex">
                    <input
                      id="bizRegistrationName"
                      v-model="formattedBizcfw"
                      type="text"
                      :class="{ error: bizInfo.bizinfo.checkStatus == 2 }"
                      :disabled="bizInfo.bizinfo.checkStatus == 1"
                      maxlength="14"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                    />
                    <button
                      v-if="bizInfo.bizinfo.checkStatus != 1"
                      class="button square primary"
                      @click="clickBizChk('bizinfo')"
                    >
                      확인
                    </button>
                    <button
                      v-if="bizInfo.bizinfo.checkStatus == 1"
                      class="button square black"
                      @click="deleteBizChk('bizinfo')"
                    >
                      삭제
                    </button>
                  </div>
                  <div v-if="bizInfo.bizinfo.checkStatus == 2" class="error__text">
                    {{ bizInfo.bizinfo.statusMsg }}
                  </div>
                </div>
              </div>
              <div v-if="bizInfo.bizinfo.checkStatus == 1" class="input__wrap result">
                사업자 번호 : {{ formattedBizno }}
              </div>
            </div>
            <div class="common__item__wrap">
              <div class="input__wrap">
                <div class="common__item__input">
                  <label class="input__label" for="standardFin1">표준재무제표증명</label>
                  <div class="flex">
                    <input
                      id="standardFin1"
                      v-model="formattedFin1cfw"
                      type="text"
                      :class="{ error: bizInfo.fin1info.checkStatus == 2 }"
                      :disabled="bizInfo.fin1info.checkStatus == 1"
                      maxlength="14"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                    />
                    <button
                      v-if="bizInfo.fin1info.checkStatus != 1"
                      class="button square primary"
                      @click="clickBizChk('fin1info')"
                    >
                      확인
                    </button>
                    <button
                      v-if="bizInfo.fin1info.checkStatus == 1"
                      class="button square black"
                      @click="deleteBizChk('fin1info')"
                    >
                      삭제
                    </button>
                  </div>
                  <div v-if="bizInfo.fin1info.checkStatus == 2" class="error__text">
                    {{ bizInfo.fin1info.statusMsg }}
                  </div>
                </div>
              </div>
              <div class="input__wrap result">{{ bizInfo.fin1info.checkMsg }}</div>
              <div class="input__wrap">
                <div class="common__item__input">
                  <label class="input__label" for="standardFin2">표준재무제표증명</label>
                  <div class="flex">
                    <input
                      id="standardFin2"
                      v-model="formattedFin2cfw"
                      type="text"
                      :class="{ error: bizInfo.fin2info.checkStatus == 2 }"
                      :disabled="bizInfo.fin2info.checkStatus == 1"
                      maxlength="14"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                    />
                    <button
                      v-if="bizInfo.fin2info.checkStatus != 1"
                      class="button square primary"
                      @click="clickBizChk('fin2info')"
                    >
                      확인
                    </button>
                    <button
                      v-if="bizInfo.fin2info.checkStatus == 1"
                      class="button square black"
                      @click="deleteBizChk('fin2info')"
                    >
                      삭제
                    </button>
                  </div>
                  <div v-if="bizInfo.fin2info.checkStatus == 2" class="error__text">
                    {{ bizInfo.fin2info.statusMsg }}
                  </div>
                </div>
              </div>
              <div class="input__wrap result">{{ bizInfo.fin2info.checkMsg }}</div>
              <div class="input__wrap">
                <div class="common__item__input">
                  <label class="input__label" for="standardFin3">표준재무제표증명</label>
                  <div class="flex">
                    <input
                      id="standardFin3"
                      v-model="formattedFin3cfw"
                      type="text"
                      :class="{ error: bizInfo.fin3info.checkStatus == 2 }"
                      :disabled="bizInfo.fin3info.checkStatus == 1"
                      maxlength="14"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                    />
                    <button
                      v-if="bizInfo.fin3info.checkStatus != 1"
                      class="button square primary"
                      @click="clickBizChk('fin3info')"
                    >
                      확인
                    </button>
                    <button
                      v-if="bizInfo.fin3info.checkStatus == 1"
                      class="button square black"
                      @click="deleteBizChk('fin3info')"
                    >
                      삭제
                    </button>
                  </div>
                  <div v-if="bizInfo.fin3info.checkStatus == 2" class="error__text">
                    {{ bizInfo.fin3info.statusMsg }}
                  </div>
                </div>
              </div>
              <div class="input__wrap result">{{ bizInfo.fin3info.checkMsg }}</div>
            </div>
          </div>
        </div>
        <div class="section__wrap">
          <div class="section__header">
            <div class="section__title">직장 정보 업데이트 안내</div>
          </div>
          <ul class="common__list">
            <li class="common__item">
              <div class="image__wrap">
                <img src="@/assets/images/illust_certificate@3x.png" alt="image" />
              </div>
              <div class="common__item__desc__wrap pa-8">
                <span class="common__item__desc">
                  국세청 홈택스 (www.hometax.go.kr)에서 제공하는 표준재무제표 증명원 및 사업자등록
                  증명원에 기재된 발급번호 입력을 통해 직장 정보를 업데이트 할 수 있습니다.
                  <br />
                  <br />*표준재무제표 증명원 및 사업자등록 증명원의 유효기간은
                  <span class="error__text">발급일로부터 3개월(90일)</span>
                  입니다.
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { certificateBizno } from "@/api/niceApi.js";
import { mapGetters } from "vuex";
import { TXVSREQPGMDIVCD } from "@/constant.js";

export default {
  name: "UpdateRequestInfo",
  computed: {
    ...mapGetters(["bizInfo"]),
    formattedBizno: {
      get() {
        return this.bizInfo.bizno.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      },
      set(value) {
        // eslint-disable-next-line no-useless-escape
        value = value.replace(/\-/g, "");
        this.$store.commit("BizInfo/SET_BIZNO", value);
      },
    },
    formattedBizcfw: {
      get() {
        return this.bizInfo.bizinfo.cfwNo.replace(/(\d{4})(\d{3})(\d{4})(\d{3})/, "$1-$2-$3-$4");
      },
      set(value) {
        // eslint-disable-next-line no-useless-escape
        value = value.replace(/\-/g, "");
        this.$store.commit("BizInfo/SET_BIZCFW", value);
        if (value === "") this.$store.commit("BizInfo/SET_INITINFO", "bizinfo");
      },
    },
    formattedFin1cfw: {
      get() {
        return this.bizInfo.fin1info.cfwNo.replace(/(\d{4})(\d{3})(\d{4})(\d{3})/, "$1-$2-$3-$4");
      },
      set(value) {
        // eslint-disable-next-line no-useless-escape
        value = value.replace(/\-/g, "");
        this.$store.commit("BizInfo/SET_FIN1CFW", value);
        if (value === "") this.$store.commit("BizInfo/SET_INITINFO", "fin1info");
      },
    },
    formattedFin2cfw: {
      get() {
        return this.bizInfo.fin2info.cfwNo.replace(/(\d{4})(\d{3})(\d{4})(\d{3})/, "$1-$2-$3-$4");
      },
      set(value) {
        // eslint-disable-next-line no-useless-escape
        value = value.replace(/\-/g, "");
        this.$store.commit("BizInfo/SET_FIN2CFW", value);
        if (value === "") this.$store.commit("BizInfo/SET_INITINFO", "fin2info");
      },
    },
    formattedFin3cfw: {
      get() {
        return this.bizInfo.fin3info.cfwNo.replace(/(\d{4})(\d{3})(\d{4})(\d{3})/, "$1-$2-$3-$4");
      },
      set(value) {
        // eslint-disable-next-line no-useless-escape
        value = value.replace(/\-/g, "");
        this.$store.commit("BizInfo/SET_FIN3CFW", value);
        if (value === "") this.$store.commit("BizInfo/SET_INITINFO", "fin3info");
      },
    },
  },
  methods: {
    async clickBizChk(infoType) {
      if (!this.bizInfo.bizno || !this.bizInfo[infoType].cfwNo) return;
      const data = await certificateBizno({
        bizno: this.bizInfo.bizno,
        txvscfwissno: this.bizInfo[infoType].cfwNo,
        txvscfwdivcd: this.bizInfo[infoType].type,
        txvsreqpgmdivcd: TXVSREQPGMDIVCD.DATALINE,
      });
      this.$store.commit("BizInfo/SET_INFO", { infoType, data });
    },
    deleteBizChk(infoType) {
      this.$store.commit("BizInfo/SET_INITINFO", infoType);
    },
  },
};
</script>
